import styled from "@emotion/styled";
import { Box, Divider } from "@mui/material";

export const ForwardToPanelChipsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 88px;
  overflow-y: auto;
`;

export const ForwardToPanelChipsWrapper = styled(Box)`
  padding: 7px;
`;

export const ForwardToPanelChipsDivider = styled(Divider)`
  margin-bottom: 8px;
`;
